// Polyfills for browser compatibility
// This file must be imported FIRST before any other imports

import { Buffer } from 'buffer';

// Make Buffer available globally for @ton/core and other libraries
if (typeof window !== 'undefined') {
  (window as any).Buffer = Buffer;
  (window as any).global = window;
}

// Also set process.env if needed
if (typeof (window as any).process === 'undefined') {
  (window as any).process = { env: {} };
}

export {};

